/* Deniz Doğal Taş — Testler için ortak hesaplama çekirdeği
 * Burç, element, ebced, numeroloji ve taş eşleme fonksiyonları.
 * Tüm test dosyaları window.DZ üzerinden bu fonksiyonları kullanır.
 */
(function () {
  "use strict";

  var BURCLAR = {
    "Koç":     { el: "Ateş",   yonetici: "Mars",    bas: [3, 21],  bit: [4, 19],  simge: "♈", ozet: "başlatan, cesur ve doğrudan" },
    "Boğa":    { el: "Toprak", yonetici: "Venüs",   bas: [4, 20],  bit: [5, 20],  simge: "♉", ozet: "istikrarlı, duyusal ve sabırlı" },
    "İkizler": { el: "Hava",   yonetici: "Merkür",  bas: [5, 21],  bit: [6, 20],  simge: "♊", ozet: "meraklı, çevik zihinli ve iletişimci" },
    "Yengeç":  { el: "Su",     yonetici: "Ay",      bas: [6, 21],  bit: [7, 22],  simge: "♋", ozet: "koruyucu, hafızası güçlü ve duygusal" },
    "Aslan":   { el: "Ateş",   yonetici: "Güneş",   bas: [7, 23],  bit: [8, 22],  simge: "♌", ozet: "cömert, sahne alan ve yürekli" },
    "Başak":   { el: "Toprak", yonetici: "Merkür",  bas: [8, 23],  bit: [9, 22],  simge: "♍", ozet: "ayrıntıcı, çözümleyici ve hizmet eden" },
    "Terazi":  { el: "Hava",   yonetici: "Venüs",   bas: [9, 23],  bit: [10, 22], simge: "♎", ozet: "dengeleyici, estetik ve ilişkisel" },
    "Akrep":   { el: "Su",     yonetici: "Plüton",  bas: [10, 23], bit: [11, 21], simge: "♏", ozet: "derin, dönüştürücü ve sadık" },
    "Yay":     { el: "Ateş",   yonetici: "Jüpiter", bas: [11, 22], bit: [12, 21], simge: "♐", ozet: "arayışçı, açık sözlü ve genişleyen" },
    "Oğlak":   { el: "Toprak", yonetici: "Satürn",  bas: [12, 22], bit: [1, 19],  simge: "♑", ozet: "disiplinli, inşa eden ve sorumluluk alan" },
    "Kova":    { el: "Hava",   yonetici: "Uranüs",  bas: [1, 20],  bit: [2, 18],  simge: "♒", ozet: "özgün, ileri görüşlü ve topluluk odaklı" },
    "Balık":   { el: "Su",     yonetici: "Neptün",  bas: [2, 19],  bit: [3, 20],  simge: "♓", ozet: "sezgisel, şefkatli ve sınırları geçirgen" },
  };

  // Element -> öncelikli taş anahtarları (urun-indeksi.json ile aynı anahtarlar)
  var ELEMENT_TAS = {
    "Ateş":   ["sitrin", "kaplangozu", "kehribar", "yakut", "gunestasi", "lal"],
    "Toprak": ["hematit", "akik", "jasper", "aventurin", "dumanlikuvars", "bronzit"],
    "Hava":   ["ametist", "florit", "sodalit", "labradorit", "kuvars", "havlit"],
    "Su":     ["akuamarin", "aytasi", "gulkuvars", "larimar", "sedef", "kalsedon"],
  };

  // Burç -> o burçla geleneksel olarak anılan taşlar (ilk sırada en güçlü karşılık)
  var BURC_TAS = {
    "Koç":     ["yakut", "kaplangozu", "hematit", "lal"],
    "Boğa":    ["gulkuvars", "zumrut", "akik", "aventurin"],
    "İkizler": ["sitrin", "akuamarin", "apatit", "sodalit"],
    "Yengeç":  ["aytasi", "sedef", "inci", "kalsedon"],
    "Aslan":   ["kehribar", "gunestasi", "sitrin", "kaplangozu"],
    "Başak":   ["akik", "aventurin", "florit", "jasper"],
    "Terazi":  ["gulkuvars", "opal", "lapis", "kyanit"],
    "Akrep":   ["obsidyen", "malakit", "labradorit", "turmalin"],
    "Yay":     ["lapis", "turkuaz", "sitrin", "safir"],
    "Oğlak":   ["obsidyen", "hematit", "dumanlikuvars", "florit"],
    "Kova":    ["ametist", "labradorit", "amazonit", "safir"],
    "Balık":   ["ametist", "akuamarin", "aytasi", "larimar"],
  };

  /* ---------- tarih ve burç ---------- */

  function tariheCevir(s) {
    if (!s) return null;
    var p = String(s).split("-");
    if (p.length !== 3) return null;
    var y = +p[0], a = +p[1], g = +p[2];
    if (!y || !a || !g) return null;
    return { yil: y, ay: a, gun: g };
  }

  function burcBul(tarihStr) {
    var t = tariheCevir(tarihStr);
    if (!t) return "Koç";
    for (var ad in BURCLAR) {
      var b = BURCLAR[ad];
      var basAy = b.bas[0], basGun = b.bas[1], bitAy = b.bit[0], bitGun = b.bit[1];
      if (basAy <= bitAy) {
        if ((t.ay === basAy && t.gun >= basGun) || (t.ay === bitAy && t.gun <= bitGun) ||
            (t.ay > basAy && t.ay < bitAy)) return ad;
      } else {
        // Oğlak gibi yıl sınırını aşan burçlar
        if ((t.ay === basAy && t.gun >= basGun) || (t.ay === bitAy && t.gun <= bitGun) ||
            t.ay > basAy || t.ay < bitAy) return ad;
      }
    }
    return "Koç";
  }

  // Ay burcu için basitleştirilmiş kestirim: Ay ~2,5 günde bir burç değiştirir.
  // Efemeris olmadan kesin sonuç verilemez; bu yüzden sonuç metninde "yaklaşık" denir.
  function ayBurcuKestir(tarihStr) {
    var t = tariheCevir(tarihStr);
    if (!t) return "Yengeç";
    var g = Date.UTC(t.yil, t.ay - 1, t.gun) / 86400000;
    var sira = Object.keys(BURCLAR);
    // 2000-01-01 civarında Ay yaklaşık Yay burcundaydı; oradan ileri sayıyoruz
    var temel = Date.UTC(2000, 0, 1) / 86400000;
    var idx = Math.floor((((g - temel) / 2.5333) % 12 + 12) % 12);
    var yay = sira.indexOf("Yay");
    return sira[(yay + idx) % 12];
  }

  // Yükselen için doğum saati gerekir. Saat verilmezse null döner ve
  // sonuç metni bunu açıkça söyler — uydurma yükselen üretmiyoruz.
  function yukselenKestir(tarihStr, saatStr) {
    if (!saatStr) return null;
    var p = String(saatStr).split(":");
    var saat = +p[0], dk = +p[1] || 0;
    if (isNaN(saat)) return null;
    var gunes = burcBul(tarihStr);
    var sira = Object.keys(BURCLAR);
    var gi = sira.indexOf(gunes);
    // Yükselen kabaca her 2 saatte bir ilerler, şafak vakti güneş burcuyla hizalanır
    var adim = Math.floor(((saat + dk / 60) - 6 + 24) % 24 / 2);
    return sira[(gi + adim) % 12];
  }

  /* ---------- harf ve sayı sistemleri ---------- */

  // Türkçe harfler için ebced karşılıkları (Osmanlı geleneğindeki yaygın tabloya dayanır)
  var EBCED = {
    a: 1, b: 2, c: 3, ç: 3, d: 4, e: 1, f: 80, g: 3, ğ: 3, h: 5, ı: 10, i: 10,
    j: 3, k: 20, l: 30, m: 40, n: 50, o: 6, ö: 6, p: 2, r: 200, s: 60, ş: 300,
    t: 400, u: 6, ü: 6, v: 6, y: 10, z: 7, x: 60, q: 100, w: 6,
  };

  // Pisagor numerolojisi — Türkçe harfler dahil
  var PISAGOR = {
    a:1,b:2,c:3,ç:3,d:4,e:5,f:6,g:7,ğ:7,h:8,ı:9,i:9,j:1,k:2,l:3,m:4,n:5,
    o:6,ö:6,p:7,q:8,r:9,s:1,ş:1,t:2,u:3,ü:3,v:4,w:5,x:6,y:7,z:8,
  };

  function harfToplam(ad, tablo) {
    var s = String(ad || "").toLowerCase();
    var t = 0;
    for (var i = 0; i < s.length; i++) {
      var h = s[i];
      if (tablo[h]) t += tablo[h];
    }
    return t;
  }

  // Tek haneye indirger; 11, 22, 33 usta sayıları korunur
  function indirge(n, ustaKoru) {
    while (n > 9) {
      if (ustaKoru && (n === 11 || n === 22 || n === 33)) return n;
      n = String(n).split("").reduce(function (a, b) { return a + (+b); }, 0);
    }
    return n;
  }

  function yasamYolu(tarihStr) {
    var t = tariheCevir(tarihStr);
    if (!t) return 1;
    var toplam = indirge(t.gun, false) + indirge(t.ay, false) +
                 indirge(String(t.yil).split("").reduce(function (a, b) { return a + (+b); }, 0), false);
    return indirge(toplam, true);
  }

  /* ---------- taş seçimi ---------- */

  // Verilen niyet etiketlerine en çok karşılık gelen taşları puana göre sıralar
  function niyetTaslari(niyetler, adet) {
    var bilgi = (window.DENIZ_VERI && window.DENIZ_VERI.tasBilgi) || {};
    var puanlar = [];
    for (var anahtar in bilgi) {
      var tas = bilgi[anahtar];
      var p = 0;
      for (var i = 0; i < niyetler.length; i++) {
        var yer = tas.niyet.indexOf(niyetler[i]);
        if (yer !== -1) p += (niyetler.length - i) * 2 + (tas.niyet.length - yer);
      }
      if (p > 0) puanlar.push({ anahtar: anahtar, puan: p });
    }
    puanlar.sort(function (a, b) { return b.puan - a.puan; });
    var istenen = adet || 4;
    var sonuc = puanlar.slice(0, istenen).map(function (x) { return x.anahtar; });

    // Güvenlik ağı: dar bir niyet etiketi istenen sayıyı karşılamıyorsa,
    // aynı çakradan taşlarla tamamlanır. Kullanıcı her zaman dolu bir liste görür.
    if (sonuc.length < istenen && sonuc.length > 0) {
      var ilkCakra = bilgi[sonuc[0]] && bilgi[sonuc[0]].cakra;
      for (var a2 in bilgi) {
        if (sonuc.length >= istenen) break;
        if (sonuc.indexOf(a2) !== -1) continue;
        if (bilgi[a2].cakra === ilkCakra) sonuc.push(a2);
      }
    }
    return sonuc;
  }

  function cakraTaslari(cakra, adet) {
    var bilgi = (window.DENIZ_VERI && window.DENIZ_VERI.tasBilgi) || {};
    var liste = [];
    for (var a in bilgi) if (bilgi[a].cakra === cakra) liste.push(a);
    return liste.slice(0, adet || 4);
  }

  // Listeleri sırayı bozmadan birleştirir, tekrarları atar.
  // Stokta ürünü olmayan taşları ELER — kullanıcıya satın alamayacağı taş önerilmesin.
  // Bu, tek tek tabloları denetlemeye gerek bırakmayan kalıcı koruma.
  function birlestir() {
    var havuz = (window.DENIZ_VERI && window.DENIZ_VERI.taslar) || {};
    var kontrolVar = Object.keys(havuz).length > 0;
    var cikti = [], gorulen = {}, elenen = [];
    for (var i = 0; i < arguments.length; i++) {
      var liste = arguments[i] || [];
      for (var j = 0; j < liste.length; j++) {
        var a = liste[j];
        if (gorulen[a]) continue;
        gorulen[a] = 1;
        if (kontrolVar && (!havuz[a] || !havuz[a].urunler || !havuz[a].urunler.length)) {
          elenen.push(a);
          continue;
        }
        cikti.push(a);
      }
    }
    if (elenen.length && window.console && console.debug) {
      console.debug("[deniz-test] stoksuz taş elendi:", elenen.join(", "));
    }
    return cikti;
  }

  function tasAdi(anahtar) {
    var bilgi = (window.DENIZ_VERI && window.DENIZ_VERI.tasBilgi) || {};
    return (bilgi[anahtar] && bilgi[anahtar].ad) || anahtar;
  }

  function tasOzet(anahtar) {
    var bilgi = (window.DENIZ_VERI && window.DENIZ_VERI.tasBilgi) || {};
    return (bilgi[anahtar] && bilgi[anahtar].ozet) || "";
  }

  /* ---------- metin yardımcıları ---------- */

  function ilkAd(tam) {
    var s = String(tam || "").trim().split(/\s+/)[0] || "";
    return s ? s.charAt(0).toLocaleUpperCase("tr") + s.slice(1).toLocaleLowerCase("tr") : "";
  }

  // Puan sözlüğünden en yüksek anahtarı döndürür
  function baskin(puanlar) {
    var enIyi = null, enYuksek = -Infinity;
    for (var k in puanlar) if (puanlar[k] > enYuksek) { enYuksek = puanlar[k]; enIyi = k; }
    return enIyi;
  }

  // Cevap listesindeki puan nesnelerini toplar
  function puanTopla(cevaplar) {
    var t = {};
    (cevaplar || []).forEach(function (c) {
      if (!c || !c.puan) return;
      for (var k in c.puan) t[k] = (t[k] || 0) + c.puan[k];
    });
    return t;
  }

  // Puanları 0-1 aralığında ölçüm çubuklarına çevirir
  function olcumlereCevir(puanlar, adlar, renkler) {
    var toplam = 0;
    for (var k in puanlar) toplam += Math.max(0, puanlar[k]);
    if (!toplam) toplam = 1;
    return Object.keys(puanlar)
      .sort(function (a, b) { return puanlar[b] - puanlar[a]; })
      .map(function (k) {
        return {
          ad: (adlar && adlar[k]) || k,
          oran: Math.max(0, puanlar[k]) / toplam,
          renk: (renkler && renkler[k]) || null,
        };
      });
  }

  window.DZ = {
    BURCLAR: BURCLAR, ELEMENT_TAS: ELEMENT_TAS, BURC_TAS: BURC_TAS,
    EBCED: EBCED, PISAGOR: PISAGOR,
    tariheCevir: tariheCevir, burcBul: burcBul, ayBurcuKestir: ayBurcuKestir,
    yukselenKestir: yukselenKestir, harfToplam: harfToplam, indirge: indirge,
    yasamYolu: yasamYolu, niyetTaslari: niyetTaslari, cakraTaslari: cakraTaslari,
    birlestir: birlestir, tasAdi: tasAdi, tasOzet: tasOzet, ilkAd: ilkAd,
    baskin: baskin, puanTopla: puanTopla, olcumlereCevir: olcumlereCevir,
  };
})();
